import React, {Suspense} from "react";
import {Route} from "react-router";
import _ from "lodash";
import {Spin} from "antd";
import MessageBox from "../component/messagebox/MessageBox";

class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            hasError: false,
        };
    }

    static getDerivedStateFromError(error) {
        return {hasError: true};
    }

    componentDidCatch(error, errorInfo) {
        console.error(error);
    }

    render() {
        const {hasError} = this.state;
        const {children} = this.props;
        if (hasError) {
            return (
                <MessageBox
                    title="出错啦!"
                    message="组件加载失败!"
                />
            );
        }
        return children;
    }
}

const Loading = () => {
    return (
        <div
            style={{
                position: "fixed",
                top: 0,
                right: 0,
                bottom: 0,
                left: 0,
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
            }}
        >
            <Spin size="large" tip="正在加载组件..." />
        </div>
    );
};

const getLazyComp = (loader) => {
    const Comp = React.lazy(loader);

    return props => (
        <ErrorBoundary>
            <React.Suspense fallback={<Loading />}>
                <Comp {...props} />
            </React.Suspense>
        </ErrorBoundary>
    );
};

const getRoutes = (list, baseUrl = "") => {
    return _.chain(list)
        .flatMap((item) => {
            const path = `${baseUrl}/${item.key}`;
            let result = [];
            if (item.children) {
                result = getRoutes(item.children, path);
            }

            if (item.component) {
                const Component = getLazyComp(item.component);
                result.push(<Route key={path} path={path} element={<Component {...item.props} />} />);
            }

            return result;
        })
        .value();
};


export default {
    getRoutes,
};
